// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ns-tooltip-box[data-v-025fc407]{position:absolute;left:0;top:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
